var React = require('react');

function IconChat (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0-1h24v24H0z","key":0}),React.createElement("g",{"stroke":"#FFF","strokeLinecap":"square","strokeWidth":"2","key":1},React.createElement("path",{"d":"M20.4 15.8C22 14.2 23 12.2 23 10c0-5-4.9-9-11-9S1 5 1 10s4.9 9 11 9c1.1 0 2.1-.1 3.1-.4L21 21l-.6-5.2zM8 8h8M8 12h5"}))]));
}

IconChat.defaultProps = {"width":"24","height":"23","viewBox":"0 0 24 23"};

module.exports = IconChat;

IconChat.default = IconChat;
